"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarMonth = void 0;

var _preact = require("preact");

var _ChevronLeft = _interopRequireDefault(require("@insided/shared/icons/ChevronLeft"));

var _ChevronRight = _interopRequireDefault(require("@insided/shared/icons/ChevronRight"));

var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

var CalendarMonth = function CalendarMonth(_ref) {
  var month = _ref.month,
      year = _ref.year,
      onChangeMonth = _ref.onChangeMonth;
  return (0, _preact.h)("div", {
    className: "a-calendar-month"
  }, (0, _preact.h)("span", {
    onClick: function onClick() {
      return onChangeMonth(-1);
    }
  }, (0, _preact.h)(_ChevronLeft.default, null)), "".concat(months[month], " ").concat(year), (0, _preact.h)("span", {
    onClick: function onClick() {
      return onChangeMonth(1);
    }
  }, (0, _preact.h)(_ChevronRight.default, null)));
};

exports.CalendarMonth = CalendarMonth;